import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { asyncUpdateFeeses } from "../../../../store/renewal/renewal-async";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setCommon } from "../../../../store/common/common-slice";

interface IStandardModal {
  open: boolean;
  setOpen: (value: boolean) => void;
  record: IObject | null;
  fetchData: () => void;
}

const standardFeeFields = [
  { key: "standard_media_package", label: "Media Package" },
  { key: "standard_pet_fee", label: "Pet Fee" },
  { key: "standard_garage_income", label: "Garage Income" },
  { key: "standard_ami", label: "Garden Box Fees" },
  { key: "standard_bike", label: "Bike Fees" },
  { key: "standard_eccs", label: "EV Stall Fees" },
  { key: "standard_hoa", label: "HOA Fees" },
  { key: "standard_insw", label: "Insurance Waiver Fees" },
  { key: "standard_pss", label: "Parking Surface Stall Fees" },
  { key: "standard_short", label: "Short Term Lease Fees" },
  { key: "standard_stor", label: "Storage Fees" },
];

const StandardModal = ({
  open,
  setOpen,
  record,
  fetchData,
}: IStandardModal) => {
  const [form] = Form.useForm();
  const { loading } = useAppSelector((s) => s.common);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue({ ...record });
    }
  }, [open, record?.pk_id]);

  const onCreate = async (values: IObject) => {
    try {
      dispatch(setCommon({ loading: true }));
      const obj = { ...values, pk_id: record!.pk_id, type: "standard" };
      await dispatch(asyncUpdateFeeses(obj));
      setOpen(false);
      fetchData();
    } catch (err: any) {
      console.error(err);
    } finally {
      dispatch(setCommon({ loading: false }));
    }
  };

  return (
    <Modal
      open={open}
      okText={loading ? "Updating..." : "Update"}
      okButtonProps={{ disabled: loading }}
      cancelText="Cancel"
      cancelButtonProps={{ disabled: loading }}
      onCancel={() => setOpen(false)}
      onOk={() => form.validateFields().then(onCreate).catch(console.log)}
    >
      <Form form={form} layout="horizontal" preserve={false} disabled={loading}>
        {standardFeeFields
          .filter((f) => record && f.key in record)
          .map((field) => (
            <Form.Item
              key={field.key}
              name={field.key}
              label={field.label}
              rules={[
                { required: true, message: `Please input ${field.label}` },
              ]}
            >
              <Input />
            </Form.Item>
          ))}
      </Form>
    </Modal>
  );
};

export default StandardModal;